<template>
    <b-container fluid>
        <b-overlay :show="customLoading" rounded="sm">
            <iq-card>
                <template v-slot:headerTitle>
                    <h4 class="card-title">{{ $t('accommodation_management.batch_wise_trainee_trainer') + ' ' + $t('globalTrans.list') }}</h4>
                </template>
                <template v-slot:body>
                        <b-row>
                            <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                                <b class="text-dark">{{ $t('globalTrans.fiscal_year') }}</b>
                            </b-col>
                            <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                                <span class="text-dark">{{ getFiscalYear(formData.fiscal_year_id) }}</span>
                            </b-col>
                            <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                                <b class="text-dark">{{ $t('trainer_trainee.circular_memo_no') }}</b>
                            </b-col>
                            <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                                <span class="text-dark">{{ getCircularMemo(formData.circular_publication_id) }}</span>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                                <b class="text-dark">{{ $t('trainer_trainee.training_title') }}</b>
                            </b-col>
                            <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                                <span class="text-dark">{{ getTraining(formData.training_title_id) }}</span>
                            </b-col>
                            <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                                <b class="text-dark">{{ $t('trainer_trainee.batch') }}</b>
                            </b-col>
                            <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                                <span class="text-dark">{{ getBatch(formData.batch_id) }}</span>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col sm="12" md="12" lg="12">
                                <table class="table table-sm table-bordered">
                                    <thead>
                                        <tr>
                                            <th class="text-center" >{{ $t('globalTrans.sl_no') }}</th>
                                            <th class="text-center" >{{ $t('globalTrans.type') }}</th>
                                            <th class="text-center" >{{ $t('elearning_config.name') }}</th>
                                            <th class="text-center" >{{ $t('accommodation_management.check_in') }}</th>
                                            <th class="text-center" >{{ $t('accommodation_management.check_out') }}</th>
                                            <th class="text-center" >{{ $t('elearning_config.guest_house') }}</th>
                                            <th class="text-center" >{{ $t('elearning_config.room_type') }}</th>
                                            <th class="text-center" >{{ $t('child_admission_management.contact_no') }}</th>
                                            <th class="text-center" >{{ $t('globalTrans.action') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="formData.details && formData.details.length > 0">
                                            <tr v-for="(item, index) in formData.details" :key="index">
                                                <td class="text-center">{{ $n(index + 1) }}</td>
                                                <td class="text-center">{{ getType(item.is_trainee) }}</td>
                                                <td class="text-center" v-if="item.is_trainee === 1">{{ currentLocale === 'bn' ? item.trainee.name_bn : item.trainee.name }}</td>
                                                <td class="text-center" v-if="item.is_trainee === 2">{{ currentLocale === 'bn' ? item.trainer.name_bn : item.trainer.name }}</td>
                                                <td class="text-center">{{ item.check_in | dateFormat }}</td>
                                                <td class="text-center">{{ item.check_out | dateFormat }}</td>
                                                <td class="text-center">{{ getGuestHouse(item.guesthouse_main_id) }}</td>
                                                <td class="text-center">{{ getRoomType(item.room_type_main_id) }}</td>
                                                <td class="text-center">{{ item.phone_no | mobileNumber }}</td>
                                                <td class="text-center">
                                                    <b-button v-b-modal.modal-4 variant=" iq-bg-success mr-1 mb-1" size="sm" @click="edit(item)"><i class="ri-ball-pen-fill m-0"></i></b-button>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr>
                                                <td colspan="13" align="center">{{ $t('globalTrans.noDataFound') }}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </b-col>
                        </b-row>
                        <div class="row">
                            <div class="col-sm-3"></div>
                            <div class="col text-right">
                                <router-link :to="{ name: 'training_e_learning_service.accommodation_management.accommodation_info' }" :class="'btn btn-success text-light fontcus'">
                                    {{ $t('globalTrans.back')}}
                                </router-link>
                            </div>
                        </div>
                </template>
            </iq-card>
        </b-overlay>
        <b-modal id="modal-4" size="xl" :title="formTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
            <Edit :item="editItem" :key="editItemId"/>
        </b-modal>
    </b-container>
</template>
<script>
    import Edit from './Edit'
    export default {
        props: ['item'],
        components: {
            Edit
        },
        data () {
            return {
                formData: {
                    fiscal_year_id: 0,
                    circular_publication_id: 0,
                    training_title_id: 0,
                    batch_id: 0,
                    traineeList: []
                },
                editItemId: 0,
                editItem: [],
                alreadyExist: [],
                customLoading: false
            }
        },
        computed: {
            currentLocale () {
                return this.$i18n.locale
            },
            formTitle () {
                return this.$t('accommodation_management.accommodation_info') + ' ' + this.$t('globalTrans.modify')
            },
            getTypeList: function () {
                return [
                    { value: 1, text: this.$t('trainer_trainee.trainee') },
                    { value: 2, text: this.$t('trainer_trainee.trainers') }
                ]
            }
        },
        watch: {
        },
        created () {
            if (this.$route.params.item) {
                this.formData = this.$route.params.item
            } else {
                this.$router.push({ name: 'training_e_learning_service.accommodation_management.accommodation_info' })
            }
        },
        methods: {
            edit (edititem) {
                this.editItem = edititem
            },
            getFiscalYear (fiscalYearId) {
                const fiscalObj = this.$store.state.commonObj.fiscalYearList.find(item => item.value === fiscalYearId)
                if (this.$i18n.locale === 'bn') {
                    return fiscalObj.text_bn
                } else {
                    return fiscalObj.text_en
                }
            },
            getCircularMemo (circularMemoId) {
                const circularObj = this.$store.state.TrainingElearning.commonObj.circularMemoList.find(item => item.value === circularMemoId)
                if (this.$i18n.locale === 'bn') {
                    return circularObj.text_bn
                } else {
                    return circularObj.text_en
                }
            },
            getTraining (trainingId) {
                const trainingObj = this.$store.state.TrainingElearning.commonObj.trainingNameList.find(item => item.value === trainingId)
                if (this.$i18n.locale === 'bn') {
                    return trainingObj.text_bn
                } else {
                    return trainingObj.text_en
                }
            },
            getBatch (batchId) {
                const batchObj = this.$store.state.TrainingElearning.commonObj.batchList.find(item => item.value === batchId)
                if (this.$i18n.locale === 'bn') {
                    return batchObj.text_bn
                } else {
                    return batchObj.text_en
                }
            },
            getType (typeId) {
                const typeObj = this.getTypeList.find(item => item.value === typeId)
                if (typeObj !== undefined) {
                    return typeObj.text
                }
            },
            getGuestHouse (gHouseId) {
                const houseObj = this.$store.state.TrainingElearning.commonObj.guestHouseList.find(item => item.value === gHouseId)
                if (houseObj !== undefined) {
                    if (this.$i18n.locale === 'bn') {
                        return houseObj.text_bn
                    } else {
                        return houseObj.text_en
                    }
                }
            },
            getRoomType (roomTypeId) {
                const roomTypeObj = this.$store.state.TrainingElearning.commonObj.roomTypeList.find(item => item.value === roomTypeId)
                if (roomTypeObj !== undefined) {
                    if (this.$i18n.locale === 'bn') {
                        return roomTypeObj.text_bn
                    } else {
                        return roomTypeObj.text_en
                    }
                }
            }
        }
    }
</script>
